<template>
  <div class="main">
    <base-card v-for="side in sides" :key="side.name">
      <v-card-title>{{ side.name }}</v-card-title>
      <v-card-actions class="flex text-right"><v-spacer></v-spacer>{{ side.price }}</v-card-actions>
    </base-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sides: [
        {
          name: "Помфрит",
          price: "60/80 ден.",
        },
        {
          name: "Павлака",
          price: "20/30 ден.",
        },
        {
          name: "Печурки",
          price: "30/40 ден.",
        },
        {
          name: "Млечен Кашкавал",
          price: "30/40 ден.",
        },
        {
          name: "Пилешка шунка",
          price: "30/40 ден.",
        },
        {
          name: "Лепиња",
          price: "30 ден.",
        },
        {
          name: "Кулен",
          price: "60 ден.",
        },
        {
          name: "Печеница",
          price: "60 ден."
        },
        {
          name: "Плескавица",
          price: "100 ден.",
        },
        {
          name: "Пилешки стек",
          price: "110 ден.",
        },
        {
          name: "Растурен",
          price: "30 ден.",
        },
        {
          name: "Цезар сос",
          price: "20 ден.",
        },
        {
          name: "Прибор",
          price: "10 ден.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.main {
  min-height: 200vh;
  background: transparent;
}
</style>
